<template>
  <div class="navbar">
    <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <span> {{ userInfo.name }}</span>
          <!-- <span class="info">(用户名:{{ userDetail.account }})</span> -->
          <!-- <img :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar"> -->
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/systemSource/userInfo">
            <el-dropdown-item>
              个人中心
              <!-- {{ $t("navbar.profile") }} -->
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            退出登录
            <!-- <span style="display: block">{{ $t("navbar.logOut") }}</span> -->
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { getProfile ,getUserInfoByLoginId} from '@/api/systemData';
import {getToken,setToken,removeToken} from '@/utils/auth'
export default {
  components: {
  },
  data() {
    return {
      userInfo:{},
    };
  },
  computed: {
    
  },
  created() {
    getProfile().then((res)=>{
      console.log("profile--res",res);
    })
    getUserInfoByLoginId().then((res)=>{
      if(res.code == 10000){
        this.userInfo = res.data;
      }
    })
  },
  methods: {
    logout(){
      //将cookie中的token删除
      removeToken();
      this.$router.push('/'); // 跳转到登录页面
    }
  },
};
</script>

<style lang="less" scoped>
.navbar {
  height: 30px;
  width:100%;
  overflow: hidden;
  position: relative;
  background: #fff;
  // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  ::v-deep .el-dropdown{
    float:right;
    margin-bottom:-10px;
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      // display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        .info {
          display: inline-block;
          font-size: 14px;
          margin-left: 10px;
        }
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
